import { Box, Section, Text } from "@vinomofo/components";

import { COLORS } from "../../styles";
import { CartDropdown } from "../cart-dropdown";
import { HeaderAuth } from "./HeaderAuth";
import { HeaderCategoryNav } from "./HeaderCategoryNav";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderSearch } from "./HeaderSearch";
import { storefrontNavigationItemProps } from "../../types/vino-data-types";
import styled from "styled-components";
import LoginSignup from "./LoginSignup";
import {
  isVinomofo,
  isWhiskymofo,
  isWhiskymofoSignupPage,
} from "../../utils/is-page";
import { useLocation } from "@reach/router";
import useAuth from "../../hooks/use-auth";
import { trackEvent } from "../../utils/track-event";
import { SHOW_TOGGLE } from "../../utils/constants";

const StyledToggleSwitchBox = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  padding-left: 10px;

  @media ${({ theme }) => theme.mq.max.mobile} {
    gap: 5px;
  }
`;

const ToggleWrap = styled(Box)`
  width: 50px;
  height: 26px;
  border-radius: 20px;
  background-color: #303030;
  padding: 2px;
  border: 1px solid #777;
  cursor: pointer;
`;

const ToggleValue = styled(Box)<{ value: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: ${({ value }) =>
    value === true ? COLORS.mofoGold : COLORS.mofoGreen};
  float: ${({ value }) => (value === true ? "right" : "left")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
`;

const DesktopText = styled(Text)`
  display: block;

  @media ${({ theme }) => theme.mq.max.mobile} {
    display: none;
  }
`;

const MobileText = styled(Text)`
  display: none;

  @media ${({ theme }) => theme.mq.max.mobile} {
    display: block;
  }
`;

export const SiteToggle = ({
  value,
  showLabel = true,
}: {
  value: boolean;
  showLabel?: boolean;
}) => {
  const { isAuthenticated } = useAuth();
  const showToggle = process.env.GATSBY_SHOW_TOGGLE === "true";

  const base = process.env.GATSBY_VM_WM_APP_URL!;
  const toggleUrl = new URL(base?.endsWith("/") ? base : base + "/");

  if (isAuthenticated) {
    if (isVinomofo) {
      toggleUrl.pathname = "deals";
    }
    toggleUrl.searchParams.set("sso", "1");
  }

  if (!showToggle) return null;

  return (
    <StyledToggleSwitchBox
      onClick={() => {
        trackEvent("Toggle Clcked", {
          action: isWhiskymofo ? "WM to VM" : "VM to WM",
        });
      }}
    >
      <DesktopText fontSize={"9px"} color="white" fontWeight="500">
        VINOMOFO
      </DesktopText>
      {showLabel && (
        <MobileText fontSize={"9px"} color="white" fontWeight="500">
          VM
        </MobileText>
      )}
      <a href={toggleUrl.toString()}>
        <ToggleWrap>
          <ToggleValue value={value}>{value ? "🥃" : "🍷"}</ToggleValue>
        </ToggleWrap>
      </a>
      <DesktopText fontSize={"9px"} color="white" fontWeight="500">
        WHISKYMOFO
      </DesktopText>
      {showLabel && (
        <MobileText fontSize={"9px"} color="white" fontWeight="500">
          WM
        </MobileText>
      )}
    </StyledToggleSwitchBox>
  );
};

export const HeaderWide = ({
  menuItems,
  transparentHeader = false,
}: {
  menuItems: storefrontNavigationItemProps[];
  transparentHeader: boolean;
}): JSX.Element => {
  const location = useLocation();
  return (
    <Section
      py={["15px", "20px", "20px"]}
      backgroundColor={transparentHeader ? "transparent" : "#091111"}
      borderBottom={
        transparentHeader ? ["1px solid rgba(255, 255, 255, .25)"] : 0
      }
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        {SHOW_TOGGLE ? (
          <Box width={"33.3%"}>
            <SiteToggle value={isWhiskymofo} />
          </Box>
        ) : (
          <Box width={"33.3%"} flexGrow={3} flexShrink={1} flexBasis={0} />
        )}
        <Box
          width={"33.3%"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <HeaderLogo
            height={["25px", "35px", "40px"]}
            isWhiskymofo={isWhiskymofo}
          />
        </Box>
        <Box
          as="nav"
          display="flex"
          width={"33.3%"}
          justifyContent="flex-end"
          alignItems="center"
          gridGap={[3, 3, 4]}
        >
          {isWhiskymofoSignupPage(location?.pathname) ? (
            <LoginSignup />
          ) : (
            <Box display="flex" alignItems="center" gridGap={[3, 3, 4]}>
              <HeaderAuth isLarge />
              {!isWhiskymofo && <HeaderSearch />}
              <CartDropdown isLarge />
            </Box>
          )}
        </Box>
      </Box>
      {/* {withCategoryNavigation ? ( */}
      {menuItems.length > 0 && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexBasis="100%"
          paddingTop="15px"
          position="relative"
        >
          <HeaderCategoryNav menuItems={menuItems} fontSize={[0, 1]} />
        </Box>
      )}
      {/* ) : null} */}
    </Section>
  );
};
